/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VerifySubscriptionImport } from './routes/verify-subscription'
import { Route as VerifyEmailImport } from './routes/verify-email'
import { Route as SignUpImport } from './routes/sign-up'
import { Route as ShareImport } from './routes/share'
import { Route as ServiceDownImport } from './routes/service-down'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as ReactivationImport } from './routes/reactivation'
import { Route as PopoutAudioImport } from './routes/popout-audio'
import { Route as PlansImport } from './routes/plans'
import { Route as PasswordResetImport } from './routes/password-reset'
import { Route as LoginImport } from './routes/login'
import { Route as InviteImport } from './routes/invite'
import { Route as GetStartedImport } from './routes/get-started'
import { Route as FeedsImport } from './routes/feeds'
import { Route as CheckoutImport } from './routes/checkout'
import { Route as AuthSuccessImport } from './routes/auth-success'
import { Route as AuthImport } from './routes/auth'
import { Route as IndexImport } from './routes/index'
import { Route as FunnelAnalyzerIndexImport } from './routes/funnel-analyzer.index'
import { Route as FeedsTestingLabsIndexImport } from './routes/feeds.testing-labs.index'
import { Route as FeedsTemplatesIndexImport } from './routes/feeds.templates.index'
import { Route as FeedsSavedIndexImport } from './routes/feeds.saved.index'
import { Route as FeedsRequestedIndexImport } from './routes/feeds.requested.index'
import { Route as FeedsLiveTrendsIndexImport } from './routes/feeds.live-trends.index'
import { Route as FeedsInspirationIndexImport } from './routes/feeds.inspiration.index'
import { Route as FeedsHiddenGemsIndexImport } from './routes/feeds.hidden-gems.index'
import { Route as FeedsEvergreenIndexImport } from './routes/feeds.evergreen.index'
import { Route as FeedsCreativeToolkitIndexImport } from './routes/feeds.creative-toolkit.index'
import { Route as FeedsCollectionsIndexImport } from './routes/feeds.collections.index'
import { Route as FeedsBrandsIndexImport } from './routes/feeds.brands.index'
import { Route as FeedsBoardsIndexImport } from './routes/feeds.boards.index'
import { Route as ShareTemplatesAdIDImport } from './routes/share.templates.$adID'
import { Route as ShareInspirationAdIDImport } from './routes/share.inspiration.$adID'
import { Route as FeedsTemplatesAdIDImport } from './routes/feeds.templates.$adID'
import { Route as FeedsSearchExpertsImport } from './routes/feeds.search.experts'
import { Route as FeedsSearchBrandsImport } from './routes/feeds.search.brands'
import { Route as FeedsSavedEmailsImport } from './routes/feeds.saved.emails'
import { Route as FeedsSavedEmailTemplatesImport } from './routes/feeds.saved.email-templates'
import { Route as FeedsSavedAdsImport } from './routes/feeds.saved.ads'
import { Route as FeedsSavedAdTemplatesImport } from './routes/feeds.saved.ad-templates'
import { Route as FeedsSavedAdLandersImport } from './routes/feeds.saved.ad-landers'
import { Route as FeedsSavedAdLanderTemplatesImport } from './routes/feeds.saved.ad-lander-templates'
import { Route as FeedsInspirationAdIDImport } from './routes/feeds.inspiration.$adID'
import { Route as FeedsCollectionsCollectionIDImport } from './routes/feeds.collections.$collectionID'
import { Route as FeedsTemplatesLandingPagesIndexImport } from './routes/feeds.templates.landing-pages.index'
import { Route as FeedsTemplatesEmailsIndexImport } from './routes/feeds.templates.emails.index'
import { Route as FeedsRequestedLandingPagesIndexImport } from './routes/feeds.requested.landing-pages.index'
import { Route as FeedsRequestedEmailsIndexImport } from './routes/feeds.requested.emails.index'
import { Route as FeedsInspirationLandingPagesIndexImport } from './routes/feeds.inspiration.landing-pages.index'
import { Route as FeedsInspirationEmailsIndexImport } from './routes/feeds.inspiration.emails.index'
import { Route as FeedsCreativeToolkitFunnelCreativeAnalyzerIndexImport } from './routes/feeds.creative-toolkit.funnel-creative-analyzer.index'
import { Route as FeedsCreativeToolkitCreativeAnalysisIndexImport } from './routes/feeds.creative-toolkit.creative-analysis.index'
import { Route as FeedsCreativeToolkitCopyGraderIndexImport } from './routes/feeds.creative-toolkit.copy-grader.index'
import { Route as FeedsCreativeToolkitAdTestCalculatorIndexImport } from './routes/feeds.creative-toolkit.ad-test-calculator.index'
import { Route as FeedsCollectionsExpertsIndexImport } from './routes/feeds.collections.experts.index'
import { Route as FeedsCollectionsCreativeosIndexImport } from './routes/feeds.collections.creativeos.index'
import { Route as FeedsBrandsBrandIDIndexImport } from './routes/feeds.brands.$brandID.index'
import { Route as ShareTemplatesLandingPagesAdIDImport } from './routes/share.templates.landing-pages.$adID'
import { Route as ShareTemplatesEmailsAdIDImport } from './routes/share.templates.emails.$adID'
import { Route as ShareInspirationLandingPagesAdIDImport } from './routes/share.inspiration.landing-pages.$adID'
import { Route as ShareInspirationEmailsAdIDImport } from './routes/share.inspiration.emails.$adID'
import { Route as FeedsSearchTemplatesLandingPagesImport } from './routes/feeds.search.templates.landing-pages'
import { Route as FeedsSearchTemplatesEmailsImport } from './routes/feeds.search.templates.emails'
import { Route as FeedsSearchTemplatesAdsImport } from './routes/feeds.search.templates.ads'
import { Route as FeedsSearchInspirationLandingPagesImport } from './routes/feeds.search.inspiration.landing-pages'
import { Route as FeedsSearchInspirationEmailsImport } from './routes/feeds.search.inspiration.emails'
import { Route as FeedsSearchInspirationAdsImport } from './routes/feeds.search.inspiration.ads'
import { Route as FeedsInspirationLandingPagesAdIDImport } from './routes/feeds.inspiration.landing-pages.$adID'
import { Route as FeedsBrandsBrandIDLandingPagesImport } from './routes/feeds.brands.$brandID.landing-pages'
import { Route as FeedsBrandsBrandIDEmailsImport } from './routes/feeds.brands.$brandID.emails'
import { Route as FeedsBoardsBoardIDEmailsImport } from './routes/feeds.boards.$boardID.emails'
import { Route as FeedsBoardsBoardIDEmailTemplatesImport } from './routes/feeds.boards.$boardID.email-templates'
import { Route as FeedsBoardsBoardIDAdsImport } from './routes/feeds.boards.$boardID.ads'
import { Route as FeedsBoardsBoardIDAdTemplatesImport } from './routes/feeds.boards.$boardID.ad-templates'
import { Route as FeedsBoardsBoardIDAdLandersImport } from './routes/feeds.boards.$boardID.ad-landers'
import { Route as FeedsBoardsBoardIDAdLanderTemplatesImport } from './routes/feeds.boards.$boardID.ad-lander-templates'
import { Route as FeedsCreativeToolkitFunnelCreativeAnalyzerInspirationLibraryIndexImport } from './routes/feeds.creative-toolkit.funnel-creative-analyzer.inspiration-library.index'
import { Route as FeedsCreativeToolkitFunnelCreativeAnalyzerHistoryIndexImport } from './routes/feeds.creative-toolkit.funnel-creative-analyzer.history.index'
import { Route as FeedsCollectionsExpertsLandingPagesExpertImport } from './routes/feeds.collections.experts.landing-pages.$expert'
import { Route as FeedsCollectionsExpertsEmailExpertImport } from './routes/feeds.collections.experts.email.$expert'
import { Route as FeedsCollectionsExpertsAdExpertImport } from './routes/feeds.collections.experts.ad.$expert'

// Create/Update Routes

const VerifySubscriptionRoute = VerifySubscriptionImport.update({
  path: '/verify-subscription',
  getParentRoute: () => rootRoute,
} as any)

const VerifyEmailRoute = VerifyEmailImport.update({
  path: '/verify-email',
  getParentRoute: () => rootRoute,
} as any)

const SignUpRoute = SignUpImport.update({
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const ShareRoute = ShareImport.update({
  path: '/share',
  getParentRoute: () => rootRoute,
} as any)

const ServiceDownRoute = ServiceDownImport.update({
  path: '/service-down',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const ReactivationRoute = ReactivationImport.update({
  path: '/reactivation',
  getParentRoute: () => rootRoute,
} as any)

const PopoutAudioRoute = PopoutAudioImport.update({
  path: '/popout-audio',
  getParentRoute: () => rootRoute,
} as any)

const PlansRoute = PlansImport.update({
  path: '/plans',
  getParentRoute: () => rootRoute,
} as any)

const PasswordResetRoute = PasswordResetImport.update({
  path: '/password-reset',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const InviteRoute = InviteImport.update({
  path: '/invite',
  getParentRoute: () => rootRoute,
} as any)

const GetStartedRoute = GetStartedImport.update({
  path: '/get-started',
  getParentRoute: () => rootRoute,
} as any)

const FeedsRoute = FeedsImport.update({
  path: '/feeds',
  getParentRoute: () => rootRoute,
} as any)

const CheckoutRoute = CheckoutImport.update({
  path: '/checkout',
  getParentRoute: () => rootRoute,
} as any)

const AuthSuccessRoute = AuthSuccessImport.update({
  path: '/auth-success',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const FunnelAnalyzerIndexRoute = FunnelAnalyzerIndexImport.update({
  path: '/funnel-analyzer/',
  getParentRoute: () => rootRoute,
} as any)

const FeedsTestingLabsIndexRoute = FeedsTestingLabsIndexImport.update({
  path: '/testing-labs/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsTemplatesIndexRoute = FeedsTemplatesIndexImport.update({
  path: '/templates/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsSavedIndexRoute = FeedsSavedIndexImport.update({
  path: '/saved/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsRequestedIndexRoute = FeedsRequestedIndexImport.update({
  path: '/requested/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsLiveTrendsIndexRoute = FeedsLiveTrendsIndexImport.update({
  path: '/live-trends/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsInspirationIndexRoute = FeedsInspirationIndexImport.update({
  path: '/inspiration/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsHiddenGemsIndexRoute = FeedsHiddenGemsIndexImport.update({
  path: '/hidden-gems/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsEvergreenIndexRoute = FeedsEvergreenIndexImport.update({
  path: '/evergreen/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsCreativeToolkitIndexRoute = FeedsCreativeToolkitIndexImport.update({
  path: '/creative-toolkit/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsCollectionsIndexRoute = FeedsCollectionsIndexImport.update({
  path: '/collections/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsBrandsIndexRoute = FeedsBrandsIndexImport.update({
  path: '/brands/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsBoardsIndexRoute = FeedsBoardsIndexImport.update({
  path: '/boards/',
  getParentRoute: () => FeedsRoute,
} as any)

const ShareTemplatesAdIDRoute = ShareTemplatesAdIDImport.update({
  path: '/templates/$adID',
  getParentRoute: () => ShareRoute,
} as any)

const ShareInspirationAdIDRoute = ShareInspirationAdIDImport.update({
  path: '/inspiration/$adID',
  getParentRoute: () => ShareRoute,
} as any)

const FeedsTemplatesAdIDRoute = FeedsTemplatesAdIDImport.update({
  path: '/templates/$adID',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsSearchExpertsRoute = FeedsSearchExpertsImport.update({
  path: '/search/experts',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsSearchBrandsRoute = FeedsSearchBrandsImport.update({
  path: '/search/brands',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsSavedEmailsRoute = FeedsSavedEmailsImport.update({
  path: '/saved/emails',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsSavedEmailTemplatesRoute = FeedsSavedEmailTemplatesImport.update({
  path: '/saved/email-templates',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsSavedAdsRoute = FeedsSavedAdsImport.update({
  path: '/saved/ads',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsSavedAdTemplatesRoute = FeedsSavedAdTemplatesImport.update({
  path: '/saved/ad-templates',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsSavedAdLandersRoute = FeedsSavedAdLandersImport.update({
  path: '/saved/ad-landers',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsSavedAdLanderTemplatesRoute =
  FeedsSavedAdLanderTemplatesImport.update({
    path: '/saved/ad-lander-templates',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsInspirationAdIDRoute = FeedsInspirationAdIDImport.update({
  path: '/inspiration/$adID',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsCollectionsCollectionIDRoute =
  FeedsCollectionsCollectionIDImport.update({
    path: '/collections/$collectionID',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsTemplatesLandingPagesIndexRoute =
  FeedsTemplatesLandingPagesIndexImport.update({
    path: '/templates/landing-pages/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsTemplatesEmailsIndexRoute = FeedsTemplatesEmailsIndexImport.update({
  path: '/templates/emails/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsRequestedLandingPagesIndexRoute =
  FeedsRequestedLandingPagesIndexImport.update({
    path: '/requested/landing-pages/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsRequestedEmailsIndexRoute = FeedsRequestedEmailsIndexImport.update({
  path: '/requested/emails/',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsInspirationLandingPagesIndexRoute =
  FeedsInspirationLandingPagesIndexImport.update({
    path: '/inspiration/landing-pages/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsInspirationEmailsIndexRoute =
  FeedsInspirationEmailsIndexImport.update({
    path: '/inspiration/emails/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsCreativeToolkitFunnelCreativeAnalyzerIndexRoute =
  FeedsCreativeToolkitFunnelCreativeAnalyzerIndexImport.update({
    path: '/creative-toolkit/funnel-creative-analyzer/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsCreativeToolkitCreativeAnalysisIndexRoute =
  FeedsCreativeToolkitCreativeAnalysisIndexImport.update({
    path: '/creative-toolkit/creative-analysis/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsCreativeToolkitCopyGraderIndexRoute =
  FeedsCreativeToolkitCopyGraderIndexImport.update({
    path: '/creative-toolkit/copy-grader/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsCreativeToolkitAdTestCalculatorIndexRoute =
  FeedsCreativeToolkitAdTestCalculatorIndexImport.update({
    path: '/creative-toolkit/ad-test-calculator/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsCollectionsExpertsIndexRoute =
  FeedsCollectionsExpertsIndexImport.update({
    path: '/collections/experts/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsCollectionsCreativeosIndexRoute =
  FeedsCollectionsCreativeosIndexImport.update({
    path: '/collections/creativeos/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsBrandsBrandIDIndexRoute = FeedsBrandsBrandIDIndexImport.update({
  path: '/brands/$brandID/',
  getParentRoute: () => FeedsRoute,
} as any)

const ShareTemplatesLandingPagesAdIDRoute =
  ShareTemplatesLandingPagesAdIDImport.update({
    path: '/templates/landing-pages/$adID',
    getParentRoute: () => ShareRoute,
  } as any)

const ShareTemplatesEmailsAdIDRoute = ShareTemplatesEmailsAdIDImport.update({
  path: '/templates/emails/$adID',
  getParentRoute: () => ShareRoute,
} as any)

const ShareInspirationLandingPagesAdIDRoute =
  ShareInspirationLandingPagesAdIDImport.update({
    path: '/inspiration/landing-pages/$adID',
    getParentRoute: () => ShareRoute,
  } as any)

const ShareInspirationEmailsAdIDRoute = ShareInspirationEmailsAdIDImport.update(
  {
    path: '/inspiration/emails/$adID',
    getParentRoute: () => ShareRoute,
  } as any,
)

const FeedsSearchTemplatesLandingPagesRoute =
  FeedsSearchTemplatesLandingPagesImport.update({
    path: '/search/templates/landing-pages',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsSearchTemplatesEmailsRoute = FeedsSearchTemplatesEmailsImport.update(
  {
    path: '/search/templates/emails',
    getParentRoute: () => FeedsRoute,
  } as any,
)

const FeedsSearchTemplatesAdsRoute = FeedsSearchTemplatesAdsImport.update({
  path: '/search/templates/ads',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsSearchInspirationLandingPagesRoute =
  FeedsSearchInspirationLandingPagesImport.update({
    path: '/search/inspiration/landing-pages',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsSearchInspirationEmailsRoute =
  FeedsSearchInspirationEmailsImport.update({
    path: '/search/inspiration/emails',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsSearchInspirationAdsRoute = FeedsSearchInspirationAdsImport.update({
  path: '/search/inspiration/ads',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsInspirationLandingPagesAdIDRoute =
  FeedsInspirationLandingPagesAdIDImport.update({
    path: '/inspiration/landing-pages/$adID',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsBrandsBrandIDLandingPagesRoute =
  FeedsBrandsBrandIDLandingPagesImport.update({
    path: '/brands/$brandID/landing-pages',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsBrandsBrandIDEmailsRoute = FeedsBrandsBrandIDEmailsImport.update({
  path: '/brands/$brandID/emails',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsBoardsBoardIDEmailsRoute = FeedsBoardsBoardIDEmailsImport.update({
  path: '/boards/$boardID/emails',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsBoardsBoardIDEmailTemplatesRoute =
  FeedsBoardsBoardIDEmailTemplatesImport.update({
    path: '/boards/$boardID/email-templates',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsBoardsBoardIDAdsRoute = FeedsBoardsBoardIDAdsImport.update({
  path: '/boards/$boardID/ads',
  getParentRoute: () => FeedsRoute,
} as any)

const FeedsBoardsBoardIDAdTemplatesRoute =
  FeedsBoardsBoardIDAdTemplatesImport.update({
    path: '/boards/$boardID/ad-templates',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsBoardsBoardIDAdLandersRoute =
  FeedsBoardsBoardIDAdLandersImport.update({
    path: '/boards/$boardID/ad-landers',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsBoardsBoardIDAdLanderTemplatesRoute =
  FeedsBoardsBoardIDAdLanderTemplatesImport.update({
    path: '/boards/$boardID/ad-lander-templates',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsCreativeToolkitFunnelCreativeAnalyzerInspirationLibraryIndexRoute =
  FeedsCreativeToolkitFunnelCreativeAnalyzerInspirationLibraryIndexImport.update(
    {
      path: '/creative-toolkit/funnel-creative-analyzer/inspiration-library/',
      getParentRoute: () => FeedsRoute,
    } as any,
  )

const FeedsCreativeToolkitFunnelCreativeAnalyzerHistoryIndexRoute =
  FeedsCreativeToolkitFunnelCreativeAnalyzerHistoryIndexImport.update({
    path: '/creative-toolkit/funnel-creative-analyzer/history/',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsCollectionsExpertsLandingPagesExpertRoute =
  FeedsCollectionsExpertsLandingPagesExpertImport.update({
    path: '/collections/experts/landing-pages/$expert',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsCollectionsExpertsEmailExpertRoute =
  FeedsCollectionsExpertsEmailExpertImport.update({
    path: '/collections/experts/email/$expert',
    getParentRoute: () => FeedsRoute,
  } as any)

const FeedsCollectionsExpertsAdExpertRoute =
  FeedsCollectionsExpertsAdExpertImport.update({
    path: '/collections/experts/ad/$expert',
    getParentRoute: () => FeedsRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/auth-success': {
      preLoaderRoute: typeof AuthSuccessImport
      parentRoute: typeof rootRoute
    }
    '/checkout': {
      preLoaderRoute: typeof CheckoutImport
      parentRoute: typeof rootRoute
    }
    '/feeds': {
      preLoaderRoute: typeof FeedsImport
      parentRoute: typeof rootRoute
    }
    '/get-started': {
      preLoaderRoute: typeof GetStartedImport
      parentRoute: typeof rootRoute
    }
    '/invite': {
      preLoaderRoute: typeof InviteImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/password-reset': {
      preLoaderRoute: typeof PasswordResetImport
      parentRoute: typeof rootRoute
    }
    '/plans': {
      preLoaderRoute: typeof PlansImport
      parentRoute: typeof rootRoute
    }
    '/popout-audio': {
      preLoaderRoute: typeof PopoutAudioImport
      parentRoute: typeof rootRoute
    }
    '/reactivation': {
      preLoaderRoute: typeof ReactivationImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/service-down': {
      preLoaderRoute: typeof ServiceDownImport
      parentRoute: typeof rootRoute
    }
    '/share': {
      preLoaderRoute: typeof ShareImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      preLoaderRoute: typeof SignUpImport
      parentRoute: typeof rootRoute
    }
    '/verify-email': {
      preLoaderRoute: typeof VerifyEmailImport
      parentRoute: typeof rootRoute
    }
    '/verify-subscription': {
      preLoaderRoute: typeof VerifySubscriptionImport
      parentRoute: typeof rootRoute
    }
    '/funnel-analyzer/': {
      preLoaderRoute: typeof FunnelAnalyzerIndexImport
      parentRoute: typeof rootRoute
    }
    '/feeds/collections/$collectionID': {
      preLoaderRoute: typeof FeedsCollectionsCollectionIDImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/inspiration/$adID': {
      preLoaderRoute: typeof FeedsInspirationAdIDImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/saved/ad-lander-templates': {
      preLoaderRoute: typeof FeedsSavedAdLanderTemplatesImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/saved/ad-landers': {
      preLoaderRoute: typeof FeedsSavedAdLandersImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/saved/ad-templates': {
      preLoaderRoute: typeof FeedsSavedAdTemplatesImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/saved/ads': {
      preLoaderRoute: typeof FeedsSavedAdsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/saved/email-templates': {
      preLoaderRoute: typeof FeedsSavedEmailTemplatesImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/saved/emails': {
      preLoaderRoute: typeof FeedsSavedEmailsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/search/brands': {
      preLoaderRoute: typeof FeedsSearchBrandsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/search/experts': {
      preLoaderRoute: typeof FeedsSearchExpertsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/templates/$adID': {
      preLoaderRoute: typeof FeedsTemplatesAdIDImport
      parentRoute: typeof FeedsImport
    }
    '/share/inspiration/$adID': {
      preLoaderRoute: typeof ShareInspirationAdIDImport
      parentRoute: typeof ShareImport
    }
    '/share/templates/$adID': {
      preLoaderRoute: typeof ShareTemplatesAdIDImport
      parentRoute: typeof ShareImport
    }
    '/feeds/boards/': {
      preLoaderRoute: typeof FeedsBoardsIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/brands/': {
      preLoaderRoute: typeof FeedsBrandsIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/collections/': {
      preLoaderRoute: typeof FeedsCollectionsIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/creative-toolkit/': {
      preLoaderRoute: typeof FeedsCreativeToolkitIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/evergreen/': {
      preLoaderRoute: typeof FeedsEvergreenIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/hidden-gems/': {
      preLoaderRoute: typeof FeedsHiddenGemsIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/inspiration/': {
      preLoaderRoute: typeof FeedsInspirationIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/live-trends/': {
      preLoaderRoute: typeof FeedsLiveTrendsIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/requested/': {
      preLoaderRoute: typeof FeedsRequestedIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/saved/': {
      preLoaderRoute: typeof FeedsSavedIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/templates/': {
      preLoaderRoute: typeof FeedsTemplatesIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/testing-labs/': {
      preLoaderRoute: typeof FeedsTestingLabsIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/boards/$boardID/ad-lander-templates': {
      preLoaderRoute: typeof FeedsBoardsBoardIDAdLanderTemplatesImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/boards/$boardID/ad-landers': {
      preLoaderRoute: typeof FeedsBoardsBoardIDAdLandersImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/boards/$boardID/ad-templates': {
      preLoaderRoute: typeof FeedsBoardsBoardIDAdTemplatesImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/boards/$boardID/ads': {
      preLoaderRoute: typeof FeedsBoardsBoardIDAdsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/boards/$boardID/email-templates': {
      preLoaderRoute: typeof FeedsBoardsBoardIDEmailTemplatesImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/boards/$boardID/emails': {
      preLoaderRoute: typeof FeedsBoardsBoardIDEmailsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/brands/$brandID/emails': {
      preLoaderRoute: typeof FeedsBrandsBrandIDEmailsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/brands/$brandID/landing-pages': {
      preLoaderRoute: typeof FeedsBrandsBrandIDLandingPagesImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/inspiration/landing-pages/$adID': {
      preLoaderRoute: typeof FeedsInspirationLandingPagesAdIDImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/search/inspiration/ads': {
      preLoaderRoute: typeof FeedsSearchInspirationAdsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/search/inspiration/emails': {
      preLoaderRoute: typeof FeedsSearchInspirationEmailsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/search/inspiration/landing-pages': {
      preLoaderRoute: typeof FeedsSearchInspirationLandingPagesImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/search/templates/ads': {
      preLoaderRoute: typeof FeedsSearchTemplatesAdsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/search/templates/emails': {
      preLoaderRoute: typeof FeedsSearchTemplatesEmailsImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/search/templates/landing-pages': {
      preLoaderRoute: typeof FeedsSearchTemplatesLandingPagesImport
      parentRoute: typeof FeedsImport
    }
    '/share/inspiration/emails/$adID': {
      preLoaderRoute: typeof ShareInspirationEmailsAdIDImport
      parentRoute: typeof ShareImport
    }
    '/share/inspiration/landing-pages/$adID': {
      preLoaderRoute: typeof ShareInspirationLandingPagesAdIDImport
      parentRoute: typeof ShareImport
    }
    '/share/templates/emails/$adID': {
      preLoaderRoute: typeof ShareTemplatesEmailsAdIDImport
      parentRoute: typeof ShareImport
    }
    '/share/templates/landing-pages/$adID': {
      preLoaderRoute: typeof ShareTemplatesLandingPagesAdIDImport
      parentRoute: typeof ShareImport
    }
    '/feeds/brands/$brandID/': {
      preLoaderRoute: typeof FeedsBrandsBrandIDIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/collections/creativeos/': {
      preLoaderRoute: typeof FeedsCollectionsCreativeosIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/collections/experts/': {
      preLoaderRoute: typeof FeedsCollectionsExpertsIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/creative-toolkit/ad-test-calculator/': {
      preLoaderRoute: typeof FeedsCreativeToolkitAdTestCalculatorIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/creative-toolkit/copy-grader/': {
      preLoaderRoute: typeof FeedsCreativeToolkitCopyGraderIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/creative-toolkit/creative-analysis/': {
      preLoaderRoute: typeof FeedsCreativeToolkitCreativeAnalysisIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/creative-toolkit/funnel-creative-analyzer/': {
      preLoaderRoute: typeof FeedsCreativeToolkitFunnelCreativeAnalyzerIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/inspiration/emails/': {
      preLoaderRoute: typeof FeedsInspirationEmailsIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/inspiration/landing-pages/': {
      preLoaderRoute: typeof FeedsInspirationLandingPagesIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/requested/emails/': {
      preLoaderRoute: typeof FeedsRequestedEmailsIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/requested/landing-pages/': {
      preLoaderRoute: typeof FeedsRequestedLandingPagesIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/templates/emails/': {
      preLoaderRoute: typeof FeedsTemplatesEmailsIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/templates/landing-pages/': {
      preLoaderRoute: typeof FeedsTemplatesLandingPagesIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/collections/experts/ad/$expert': {
      preLoaderRoute: typeof FeedsCollectionsExpertsAdExpertImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/collections/experts/email/$expert': {
      preLoaderRoute: typeof FeedsCollectionsExpertsEmailExpertImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/collections/experts/landing-pages/$expert': {
      preLoaderRoute: typeof FeedsCollectionsExpertsLandingPagesExpertImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/creative-toolkit/funnel-creative-analyzer/history/': {
      preLoaderRoute: typeof FeedsCreativeToolkitFunnelCreativeAnalyzerHistoryIndexImport
      parentRoute: typeof FeedsImport
    }
    '/feeds/creative-toolkit/funnel-creative-analyzer/inspiration-library/': {
      preLoaderRoute: typeof FeedsCreativeToolkitFunnelCreativeAnalyzerInspirationLibraryIndexImport
      parentRoute: typeof FeedsImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AuthRoute,
  AuthSuccessRoute,
  CheckoutRoute,
  FeedsRoute.addChildren([
    FeedsCollectionsCollectionIDRoute,
    FeedsInspirationAdIDRoute,
    FeedsSavedAdLanderTemplatesRoute,
    FeedsSavedAdLandersRoute,
    FeedsSavedAdTemplatesRoute,
    FeedsSavedAdsRoute,
    FeedsSavedEmailTemplatesRoute,
    FeedsSavedEmailsRoute,
    FeedsSearchBrandsRoute,
    FeedsSearchExpertsRoute,
    FeedsTemplatesAdIDRoute,
    FeedsBoardsIndexRoute,
    FeedsBrandsIndexRoute,
    FeedsCollectionsIndexRoute,
    FeedsCreativeToolkitIndexRoute,
    FeedsEvergreenIndexRoute,
    FeedsHiddenGemsIndexRoute,
    FeedsInspirationIndexRoute,
    FeedsLiveTrendsIndexRoute,
    FeedsRequestedIndexRoute,
    FeedsSavedIndexRoute,
    FeedsTemplatesIndexRoute,
    FeedsTestingLabsIndexRoute,
    FeedsBoardsBoardIDAdLanderTemplatesRoute,
    FeedsBoardsBoardIDAdLandersRoute,
    FeedsBoardsBoardIDAdTemplatesRoute,
    FeedsBoardsBoardIDAdsRoute,
    FeedsBoardsBoardIDEmailTemplatesRoute,
    FeedsBoardsBoardIDEmailsRoute,
    FeedsBrandsBrandIDEmailsRoute,
    FeedsBrandsBrandIDLandingPagesRoute,
    FeedsInspirationLandingPagesAdIDRoute,
    FeedsSearchInspirationAdsRoute,
    FeedsSearchInspirationEmailsRoute,
    FeedsSearchInspirationLandingPagesRoute,
    FeedsSearchTemplatesAdsRoute,
    FeedsSearchTemplatesEmailsRoute,
    FeedsSearchTemplatesLandingPagesRoute,
    FeedsBrandsBrandIDIndexRoute,
    FeedsCollectionsCreativeosIndexRoute,
    FeedsCollectionsExpertsIndexRoute,
    FeedsCreativeToolkitAdTestCalculatorIndexRoute,
    FeedsCreativeToolkitCopyGraderIndexRoute,
    FeedsCreativeToolkitCreativeAnalysisIndexRoute,
    FeedsCreativeToolkitFunnelCreativeAnalyzerIndexRoute,
    FeedsInspirationEmailsIndexRoute,
    FeedsInspirationLandingPagesIndexRoute,
    FeedsRequestedEmailsIndexRoute,
    FeedsRequestedLandingPagesIndexRoute,
    FeedsTemplatesEmailsIndexRoute,
    FeedsTemplatesLandingPagesIndexRoute,
    FeedsCollectionsExpertsAdExpertRoute,
    FeedsCollectionsExpertsEmailExpertRoute,
    FeedsCollectionsExpertsLandingPagesExpertRoute,
    FeedsCreativeToolkitFunnelCreativeAnalyzerHistoryIndexRoute,
    FeedsCreativeToolkitFunnelCreativeAnalyzerInspirationLibraryIndexRoute,
  ]),
  GetStartedRoute,
  InviteRoute,
  LoginRoute,
  PasswordResetRoute,
  PlansRoute,
  PopoutAudioRoute,
  ReactivationRoute,
  ResetPasswordRoute,
  ServiceDownRoute,
  ShareRoute.addChildren([
    ShareInspirationAdIDRoute,
    ShareTemplatesAdIDRoute,
    ShareInspirationEmailsAdIDRoute,
    ShareInspirationLandingPagesAdIDRoute,
    ShareTemplatesEmailsAdIDRoute,
    ShareTemplatesLandingPagesAdIDRoute,
  ]),
  SignUpRoute,
  VerifyEmailRoute,
  VerifySubscriptionRoute,
  FunnelAnalyzerIndexRoute,
])

/* prettier-ignore-end */
